import React, { useState, useEffect } from "react";
import "./CSs/HeroSection.css";

import slide1 from "./Images/slide1.png";
import slide2 from "./Images/slide2.png";
import slide3 from "./Images/slide3.png";
import slide4 from "./Images/slide.png";

const HeroSection = ({ openPopup, openContactPopup }) => {
  const slides = [
    {
      image: slide1,
      tag: "✦ REDUCE ELECTRICITY BILLS",
      title1: "Switch To Solar",
      highlight: "Save More",
      title2: "Live Greener",
      description:
        "Pournima Solar delivers smart and efficient solar solutions that help you achieve energy independence with advanced technology and professional installation.",
      button: "Contact Us",

      card1: "120+",
      card1Text: "Expert Solution",

      card2: "250+",
      card2Text: "Join as Dealership",
      cardBtn: "Join Us",
    },

    {
      image: slide2,
      tag: "✦ PREMIUM SOLAR PANELS",
      title1: "Empowering Homes",
      highlight: "Live Greener",
      title2: "with the Power of the Sun",
      description:
        "Imagine a world where your energy is clean, affordable, and limitless. With our cutting-edge solar solutions, you can harness the power of the sun to reduce.",
      button: "Get Started",
    },

    {
      image: slide3,
      tag: "✦ SUSTAINABLE ENERGY SOLUTIONS",
      title1: "Building A",
      highlight: "Sustainable Future",
      title2: "With Solar Power",
      description:
        "From rooftop systems to complete solar solutions, we help you generate clean energy with confidence and reliability.",
      button: "Contact Us",
    },

    {
      image: slide4,
      tag: "✦ CLEAN ENERGY FOR ALL",
      title1: "Powering",
      highlight: "Tomorrow's World",
      title2: "With Green Energy",
      description:
        "Join the renewable energy revolution with innovative solar solutions designed for homes and businesses.",
      button: "Get Started",

      card1: "1000+",
      card1Text: "Installations",

      card2: "100%",
      card2Text: "Customer Satisfaction",
      cardBtn: "Join Us",
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  const slide = slides[currentSlide];

  return (
    <section className="solar-hero">
      {/* Background Slider */}
      <div className="slider-container">
        {slides.map((item, index) => (
          <img
            key={index}
            src={item.image}
            alt={`slide-${index}`}
            className="hero-bg"
            style={{
              transform: `translateX(${(index - currentSlide) * 100}%)`,
            }}
          />
        ))}
      </div>

      <div className="hero-overlay"></div>

      {/* Content */}
      <div className="hero-content">
        <span className="hero-tag">{slide.tag}</span>

        <h1>
          {slide.title1}
          <br />
          <span className="green-text">{slide.highlight}</span>
          <br />
          {slide.title2}
        </h1>

        <p>{slide.description}</p>

        <button className="hero-btn" onClick={openContactPopup}>
          {slide.button}

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
            <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" />
          </svg>
        </button>
      </div>

      {/* Stats Cards */}
      {slide.card1 && slide.card2 && (
        <div className="hero-card">
          <div className="stat-box-hero small-card">
            <h2>{slide.card1}</h2>
            <p>{slide.card1Text}</p>
          </div>

          <div className="stat-box-hero big-card">
            <div className="card-top-hero">
              <p>{slide.card2Text}</p>
            </div>

            <h2>{slide.card2}</h2>

            <button className="join-btn" onClick={openPopup}>
              {slide.cardBtn}

              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" />
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* Dots */}
      <div className="slider-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;